/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Cart/CartRailSummary',[
    'jquery',
    'lodash',
    './CartManager',
    'global/all',
    'global/RocAnalytics'
], function ($, _, CartManager, Roc, RocAnalytics) {
    'use strict';

    var cartRailSelector = '#slideCartRail';
    var uiBlockSelector;
    var cartViewModel;
    var states;
    var countries;
    var checkoutUrl;
    var template;
    var punchoutOrder;
    var minOrderAmt = 0;

    // Custom Code : removing Roc promotional code functionality 

    //var applyPromoCodeForm = {
    //    Fields: [
    //        {
    //            "Name": 'Promotion Code',
    //            "Field": '#txtPromoCode',
    //            "Param": 'promoCode',
    //            "Type": 'Text'
    //        }
    //    ],
    //    Validate: true
    //};
    // END custom code

    var estimateShippingForm = {
        Fields: [
            {
                "Name": 'Country',
                "Field": '#estimate-shipping-country',
                "Param": 'country',
                "Type": 'Select'
            },
            {
                "Name": 'City',
                "Field": '#estimate-shipping-city',
                "Param": 'city',
                "Type": 'Text',
                'Optional': true,
                "Validators": [
                            {
                                'Type': 'RequiredIfField',
                                'ConditionalField': '#estimate-shipping-country',
                                'ConditionalFieldAttr': 'data-isPostalCodeRequired',
                                'ConditionalValue': 'false',
                                'ConditionalFieldType': 'Select'
                            }]
            },
            {
                "Name": 'Zip/Postal Code',
                "Field": '#estimate-shipping-zip',
                "Param": 'zip',
                "Type": 'Text',
                'Optional': true,
                "Validators": [
                            {
                                'Type': 'RequiredIfField',
                                'ConditionalField': '#estimate-shipping-country',
                                'ConditionalFieldAttr': 'data-isPostalCodeRequired',
                                'ConditionalValue': 'true',
                                'ConditionalFieldType': 'Select'
                            },
                            {
                                "Type": 'Zip',
                                "ReferencedField": '#estimate-shipping-country',
                                'ReferencedFieldAttr': 'data-isPostalCodeRequired',
                                'ReferencedValue': 'true',
                                'ReferencedFieldType': 'Select'
                            }
                ]
            },
            {
                "Name": 'RecipientId',
                "Field": '#estimate-shipping-recipient-id',
                "Param": 'recipientId',
                "Type": 'Hidden'
            }
        ],
        Validate: true
    };

    var btns = {
        processCheckout: '#btnProceedCheckout',
        estimateShipping: '#estimate-shipping',
        applyPromoCode: '#btnApplyPromoCode',
        removePromoCode: '.removePromoCode'
    };

    function bindViewModel() {
       //Customization : sort items by create date
        $.each(cartViewModel.recipients, function (indexRecipient, recipient) {
            $.each(recipient.items, function (indexItem, item) {
                //Customization : getting item availability
                var cartItemAvailability = Roc.Extensions.getAttributeValue(item, "cartItemAvailability");
                if (cartItemAvailability) {
                    item.itemAvailability = Roc.Extensions.toCamelCase(JSON.parse(cartItemAvailability));
                }
            })
            
            recipient.items = _.sortBy(recipient.items, ['createDate']);
        });
        // Customization: hide shipping estimator
        Roc.UI.template(template, cartViewModel).then(function (renderedTemplate) {
            $(cartRailSelector).html(renderedTemplate);
        });
    }

    function reload(data) {
        cartViewModel = data;
        cartViewModel.canProceedToCheckout = cartViewModel.subtotal >= minOrderAmt;
        Roc.UI.unblock(uiBlockSelector);
        bindViewModel();
    };

    function getCart(forceRecalculate) {
        Roc.UI.block(uiBlockSelector);
        CartManager.getCurrentCart(forceRecalculate);
    }
    // Custom Code : removing Roc promotional code functionality 

    //function applyPromoCodeCompleted(xhr) {
    //    var data = xhr.responseJSON || {};

    //    if (data.status !== 200 && data.message) {
    //        if (data.message === 'Not found') {
    //            data.message = 'Sorry, the promotion code you specified is not valid.';
    //        }

    //        Roc.UI.displayErrorPopup(data.message);
    //        Roc.UI.unblock(uiBlockSelector);
    //        RocAnalytics.recordCheckoutOption(1, data.message);
    //    } else {
    //        getCart(true);
    //        RocAnalytics.recordCheckoutOption(1, 'Promotion Applied');
    //    }

    //    Roc.Core.releaseLockedButton(btns.applyPromoCode);
    //}

    //function applyPromoCodeEvt() {
    //    $(document).on('click', btns.applyPromoCode, function() {
    //        var valid = Roc.Validation.validateForm(applyPromoCodeForm);
    //        if (!valid) {
    //            return false;
    //        }
    //        Roc.Core.lockButton(btns.applyPromoCode);
    //        Roc.UI.block(uiBlockSelector);
    //        CartManager.applyPromotionCode(Roc.Forms.getFormValues(applyPromoCodeForm).promoCode);
    //        return false;
    //    });
    //}

    //function removePromoCodeCompleted(xhr) {
    //    var data = xhr.responseJSON || {};

    //    if (data.status !== 200 && data.message) {
    //        Roc.UI.displayErrorPopup(data.message);
    //        Roc.UI.unblock(uiBlockSelector);
    //        RocAnalytics.recordCheckoutOption(1, data.message);
    //    } else {
    //        getCart(true);
    //        RocAnalytics.recordCheckoutOption(1, 'Promotion Removed');
    //    }

    //    Roc.Core.releaseLockedButton(btns.applyPromoCode);
    //}

    //function removePromoCodeEvt() {
    //    $(document).on('click', btns.removePromoCode, function() {
    //        Roc.UI.block(uiBlockSelector);
    //        CartManager.removePromotionCode($(this).attr('data-code'));
    //        return false;
    //    });
    //}
    // END custom code

    function shippingMethodSelectedEvt() {
        $(document).on('click', '#shipping-options input[name="shipping"]', function (e) {
            var currentOption = $(e.currentTarget);
            var currentOptionData = currentOption.data();
            var shippingRequest = {
                recipientId: $('#estimate-shipping-recipient-id').val(),
                shippingServiceId: currentOption.val(),
                shippingServiceLabel: currentOptionData.rocParams.name
            };
            Roc.UI.block(uiBlockSelector);
            CartManager.updateShippingDetails(shippingRequest, Roc.Enums.shippingRequestType.SELECT_SERVICE);
        });
    }

    function changeCountryEvt() {
        var changeEventWithNamespace = 'change.cartRailSummary-changeCountryEvt';
        var cityField = $('#estimate-shipping-city');
        var zipField = $('#estimate-shipping-zip');
        var estimateShippingCountrySelector = '#estimate-shipping-country';
        $(document)
            .off(changeEventWithNamespace, estimateShippingCountrySelector)
            .on(changeEventWithNamespace, estimateShippingCountrySelector, function (e) {
                Roc.UI.clearFormErrors(estimateShippingForm);
                zipField.val('');
                cityField.val('');

                var isPostalCodeRequired = ($(this).find('option:selected').attr('data-isPostalCodeRequired') === "true");
                if (isPostalCodeRequired) {
                    zipField.show();
                    cityField.hide();
                } else {
                    zipField.hide();
                    cityField.show();
                }
            });

        //trigger change event to set initial state of country related fields visibility
        $('#estimate-shipping-country').trigger('change');
    }

    function goBackEvt() {
        $(document).on('click', '#shipping-options .go-back', function (e) {
            $('#shipping-options').addClass('hidden');
            $('#estimate-shipping-form').removeClass('hidden');
        });
    }

    function estimateShippingEvt() {
        $(document).on('click', btns.estimateShipping, function () {
            var valid = Roc.Validation.validateForm(estimateShippingForm);

            if (!valid) {
                if (estimateShippingForm.ErrorMsg) {
                    Roc.UI.displayErrorPopup(estimateShippingForm.ErrorMsg);
                };

                return;
            }

            Roc.Core.lockButton(btns.estimateShipping);
            Roc.UI.block(uiBlockSelector);

            var estimateShippingData = Roc.Forms.getFormValues(estimateShippingForm);

            CartManager.updateShippingDetails(estimateShippingData, Roc.Enums.shippingRequestType.UPDATE_ADDRESS);
        });
    }

    function recipientUpdatedEvt(updatedRecipient) {
        var recipientIndex = _.findIndex(cartViewModel.recipients, function (r) { return r.id === updatedRecipient.id });
        if (recipientIndex >= 0) {
            cartViewModel.recipients[recipientIndex] = updatedRecipient;
            if (updatedRecipient.itemsDeliveryType === "Shipping") {
                reload(cartViewModel);
            }
        }
    }

    function shippingUpdatedEvt(data) {
        var xhr = data.xhr;
        var response = xhr.responseJSON;

        if (xhr.status !== 200) {
            Roc.UI.unblock(uiBlockSelector);
            Roc.UI.displayErrorPopup(response.message ? response.message : 'Response error');
            Roc.Core.releaseLockedButton(btns.estimateShipping);
        } else {
            var shippingOptions = response.recipient.shippingOptions;
            if (shippingOptions === null) {
                Roc.UI.unblock(uiBlockSelector);
                Roc.UI.displayErrorPopup(response.message ? response.message : 'Please ensure your shipping information is correct to estimate shipping.');
                Roc.Core.releaseLockedButton(btns.estimateShipping);
            } else {
                getCart();
            }
        }
    }

    function bindEvents() {
        estimateShippingEvt();
        shippingMethodSelectedEvt();
        // Custom Code : removing Roc promotional code functionality 
        //applyPromoCodeEvt();
        //removePromoCodeEvt();
        // END custom code
        goBackEvt();
        Roc.EventManager.bind(Roc.Events.checkout.UPDATE_RECIPIENT, recipientUpdatedEvt);
        Roc.EventManager.bind(Roc.Events.cart.UPDATE_SHIPPING_DETAILS, shippingUpdatedEvt);
        Roc.EventManager.bind(Roc.Events.cart.GET_CURRENT_CART, reload);
        //Roc.EventManager.bind(Roc.Events.cart.APPLY_PROMO_CODE, applyPromoCodeCompleted);
        //Roc.EventManager.bind(Roc.Events.cart.REMOVE_PROMO_CODE, removePromoCodeCompleted);
        Roc.EventManager.bind(Roc.Events.users.LOGIN, function (xhr) {
            var response = xhr.responseJSON || {};
            if (response.success && response.checkoutViewModel) {
                reload(response.checkoutViewModel.order);
            }
        });
        Roc.EventManager.bind(Roc.Events.giftCards.ASSOCIATE_PAYMENT, function (response) {
            if (response.orderCart) {
                reload(response.orderCart);
            }
        });
        Roc.EventManager.bind(Roc.Events.giftCards.REMOVE_PAYMENT, function (response) {
            if (response.orderCart) {
                reload(response.orderCart);
            }
        });
    }

    function init(options) {
        minOrderAmt = options.minOrderAmt;
        cartViewModel = options.model.order;
        cartViewModel.canProceedToCheckout = cartViewModel.subtotal >= minOrderAmt;
        states = _.sortBy(options.model.states, 'stateName');
        countries = options.model.countries;
        checkoutUrl = options.checkoutUrl;
        punchoutOrder = options.punchoutOrder;
        template = options.template;
        if (options.model.isCheckoutPage) {
            uiBlockSelector = cartRailSelector;
        } else {
            uiBlockSelector = null;
        }
        bindViewModel();
        bindEvents();
    };

    var CartRailSummary = {
        init: init,
        reload: reload
    };

    Roc.Logger.debug('CartRailSummary.js Loaded:', CartRailSummary);

    return CartRailSummary;
});
